import React, { useState } from 'react';
import './Projects.css';

const projects = [
  {
    title: 'Pictaphone',
    image: '/picph.PNG',
    description: 'A online mutiplayer game similar to Pictionary. Users are given a prompt and asked to draw it.',
    contributors: ['Brian R.', 'James B.', 'Jeremy B.', 'Will F.', 'Rodrick L.'  ],
    languages: ['HTML', 'JavaScript', 'Socket.io'],
    link: 'https://cs.carleton.edu/cs_comps/2223/multiplayergame/final-results/website.html',
    linkLabel: 'View Website',
    startDate: '2022-09-01',
    endDate: '2023-03-01',
  },
  {
    title: 'Blog Site',
    image: '/vpost.PNG',
    description: 'A platform allowing signed in users to manage blogs, leave comments, like posts, and more. Admins are allowed to manage users and may utilize additional features',
    contributors: ['Rodrick L.'  ],
    languages: ['.Net', 'C#', 'Azure', "SQL"],
    link: 'https://github.com/Rodrick12123/VPost-Blog',
    linkLabel: 'View Source',
    startDate: '2023-10-01',
    endDate: '2024-08-01',
  },
  {
    title: 'Amazon Replica',
    image: '/ama.PNG',
    description: 'A React-based Amazon clone with user authentication and basket saving. Still in development.',
    contributors: ['Rodrick L.'],
    languages: ['HTML', 'JavaScript', 'React.JS', 'Firebase'],
    link: 'https://clone-311b0.web.app',
    linkLabel: 'View Website',
    startDate: '2022-02-01',
    endDate: '2022-04-15',
  },
  {
    title: 'Artificial Ecology',
    image: '/eco.PNG',
    description: 'Generates an evolving ecosystem simulating how some organisms gain an advantage in a limited ecosystem.',
    contributors: [ 'Anya V.','Rodrick L.'],
    languages: ['C++', 'R', 'HTML', 'Python'],
    link: 'https://github.com/Rodrick12123/Artificial-Ecology/tree/main',
    linkLabel: 'View Source',
    startDate: '2022-01-10',
    endDate: '2022-05-01',
  },
  {
    title: 'Computer Graphic Models',
    image: '/raster.PNG',
    description: 'Several C files for computer graphics tasks: imaging with shadows/lighting, rasterization, 3D/2D views, and camera positioning.',
    contributors: [ 'Jerimiah M.', 'Josh D.', 'Rodrick L.'],
    languages: ['C programming'],
    link: 'https://github.com/Rodrick12123/Computer-Graphics',
    linkLabel: 'View Source',
    startDate: '2023-02-01',
    endDate: '2023-04-15',
  },
  {
    title: 'World Cup Data',
    image: '/cup.PNG',
    description: 'A website for filtering World Cup data and stats using SQL and REST API.',
    contributors: ['Rodrick L.', 'Thea T.'],
    languages: ['HTML', 'Python', 'SQL', 'JavaScript'],
    link: 'https://github.com/Rodrick12123/World-Cup-Website.github.io',
    linkLabel: 'View Source',
    startDate: '2021-10-01',
    endDate: '2021-12-01',
  },
  {
    title: 'Artificial Extinction Model',
    image: '/extinct.PNG',
    description: 'Simulates an ecosystem where species can reproduce, go extinct, and mutate, leading to evolution.',
    contributors: ['Anya V.', 'Rodrick L.', 'Sam L.', 'Kai W.'],
    languages: ['C++', 'Shell', 'HTML'],
    link: 'https://github.com/Rodrick12123/Artificial-Extinction-Model',
    linkLabel: 'View Source',
    startDate: '2023-10-01',
    endDate: '2023-11-01',
  },
  {
    title: 'This Website',
    image: '/PW.PNG',
    description: 'The code for this personal website.',
    contributors: ['Rodrick L.'],
    languages: ['HTML', 'React', 'JavaScript'],
    link: 'https://github.com/Rodrick12123/Personal-Website',
    linkLabel: 'View Source',
    startDate: '2022-10-01',
    endDate: '2025-03-15',
  },
  {
    title: 'Data Up Pro',
    image: '/dataup.PNG',
    description: 'A website for automating data processing: cleaning, preprocessing, visualizations, and more.',
    contributors: ['Rodrick L.'],
    languages: ['React', 'Python', 'AWS', 'pandas', 'numpy', 'sklearn'],
    link: 'https://datauppro.com/',
    linkLabel: 'View Website',
    startDate: '2025-01-01',
    endDate: '2025-02-01',
  },
];

const sortOptions = [
  { value: 'start-asc', label: 'Date Started (Oldest First)' },
  { value: 'start-desc', label: 'Date Started (Newest First)' },
  { value: 'end-asc', label: 'Last Updated (Oldest First)' },
  { value: 'end-desc', label: 'Last Updated (Newest First)' },
  { value: 'duration-asc', label: 'Duration (Shortest First)' },
  { value: 'duration-desc', label: 'Duration (Longest First)' },
];

function getDurationDays(start, end) {
  return (new Date(end) - new Date(start)) / (1000 * 60 * 60 * 24);
}

function sortProjects(projects, sortBy) {
  const sorted = [...projects];
  switch (sortBy) {
    case 'start-asc':
      sorted.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
      break;
    case 'start-desc':
      sorted.sort((a, b) => new Date(b.startDate) - new Date(a.startDate));
      break;
    case 'end-asc':
      sorted.sort((a, b) => new Date(a.endDate) - new Date(b.endDate));
      break;
    case 'end-desc':
      sorted.sort((a, b) => new Date(b.endDate) - new Date(a.endDate));
      break;
    case 'duration-asc':
      sorted.sort((a, b) => getDurationDays(a.startDate, a.endDate) - getDurationDays(b.startDate, b.endDate));
      break;
    case 'duration-desc':
      sorted.sort((a, b) => getDurationDays(b.startDate, b.endDate) - getDurationDays(a.startDate, a.endDate));
      break;
    default:
      break;
  }
  return sorted;
}

function Projects() {
  const [sortBy, setSortBy] = useState('start-desc');
  const sortedProjects = sortProjects(projects, sortBy);

  return (
    <div className='projects'>
      <div style={{ margin: '24px 0 12px 0', textAlign: 'center' }}>
        <label htmlFor="project-sort" style={{ fontWeight: 'bold', color: 'gold', marginRight: 8 }}>Sort by:</label>
        <select
          id="project-sort"
          value={sortBy}
          onChange={e => setSortBy(e.target.value)}
          style={{ padding: '6px 12px', borderRadius: 6, border: '1.5px solid goldenrod', fontSize: '1rem' }}
        >
          {sortOptions.map(opt => (
            <option value={opt.value} key={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>
      <div className='projects_container'>
        {sortedProjects.map((project, idx) => (
          <div className='projects_indv' key={idx}>
            <a href={project.link} target='_blank' rel='noopener noreferrer'>
              <img src={project.image} alt={project.title} />
            </a>
            <div className='project_overlay'>
                <div className='project_title'>
                    <div className='description'>
                  {project.linkLabel ? (
                    <a href={project.link} target='_blank' rel='noopener noreferrer'>{project.linkLabel}</a>
                  ) : null}
                </div>
                <div className='project_name'>{project.title}</div>
                <div className='description'>{project.description}</div>
                <strong className='contributors'>Contributor(s): </strong>
                    <div className='project_contributors'>
                        
                  {project.contributors.map((name, i) => (
                    <span className='project_contributor_name' key={i}>{name}</span>
                  ))}
                </div>
                <div className='description' style={{ fontSize: '0.9rem', marginTop: 6 }}>
                  <strong>Date Started:</strong> {project.startDate} <strong>Last Updated:</strong> {project.endDate} <br />
                  <strong>Duration:</strong> {getDurationDays(project.startDate, project.endDate)} days
                </div>
                </div>
            </div>
            <div className='languages'>
              {project.languages.map((lang, lidx) => (
                <div className='language' key={lidx}>{lang}</div>
              ))}
            </div>
                    </div>
        ))}
      </div>
    </div>
  );
}

export default Projects;
